import {
	CheckinPassengerFragment,
	GdsService_OrderAdditionalServiceGdsServiceVip_Fragment,
	InputTraveller,
	PassengerFragment,
	TravellerFieldEnum
} from '@websky/graphql';

import { ServicePassengerSelected } from '../../../VipServiceSelect';

import { clearPhone } from '../../../BaseComponents/PhoneInput/utils';

import { multiplyMoney } from '@shared/lib/money';
import { Money } from '../../../types';
import { getUserValue } from '../../../utils';

export type SmsPopupFormValues = {
	[key: string]: {
		readOnly: boolean;
		selected: boolean;
		phone: string;
		id: string;
	};
};

export const getFormTravellerKey = (id: string) => `t${id}`;

export const getTotalPrice = (values: SmsPopupFormValues, price: Money) => {
	const selectedCount = Object.keys(values).filter(key => values[key].selected).length;

	return multiplyMoney(price, selectedCount);
};

export const getChangedServicesToSave = (
	values: SmsPopupFormValues,
	smsNotificationService: GdsService_OrderAdditionalServiceGdsServiceVip_Fragment,
	dirtyFields: { [key: string]: boolean }
) => {
	const servicesToAdd: ServicePassengerSelected[] = [];
	const servicesToRemove: ServicePassengerSelected[] = [];

	Object.keys(values).forEach(key => {
		if (dirtyFields[`${key}.selected`]) {
			const service: ServicePassengerSelected = {
				count: values[key].selected ? 1 : 0,
				passengerId: values[key].id,
				segmentIds: smsNotificationService.allowedSegments.map(segment => segment.toString()),
				serviceId: smsNotificationService.id,
				allowedSegments: smsNotificationService.allowedSegments
			};

			if (values[key].selected) {
				servicesToAdd.push(service);
			} else {
				service.segmentIds.forEach(segmentId => {
					servicesToRemove.push({ ...service, segmentIds: [segmentId] });
				});
			}
		}
	});

	return { servicesToAdd, servicesToRemove };
};

export const getUpdatedTravellersPhones = (
	values: SmsPopupFormValues,
	dirtyFields: { [key: string]: boolean },
	travellers: (PassengerFragment | CheckinPassengerFragment)[]
): InputTraveller[] => {
	const travellersValues: InputTraveller[] = [];
	Object.keys(values).forEach(key => {
		const traveller = travellers.find(item => item.id === values[key].id);
		const travellerPhone = clearPhone(getUserValue(traveller, TravellerFieldEnum.Phone) || '');

		const clearedPhone = clearPhone(values[key].phone || '');

		// update phone if traveller selected and phone is changed
		if (values[key].selected && dirtyFields[`${key}.phone`] && clearedPhone !== travellerPhone) {
			travellersValues.push({
				id: values[key].id,
				values: [
					{
						type: TravellerFieldEnum.Phone,
						value: clearPhone(values[key].phone),
						name: 'phone'
					}
				]
			});
		}
	});

	return travellersValues;
};
